<div class="notification-box">
  <i data-feather="bell"></i
  ><span class="badge rounded-pill badge-primary">4 </span>
</div>
<ul class="notification-dropdown onhover-show-div">
  <li>
    <i data-feather="bell"> </i>
    <h3 class="mb-0">Notifications</h3>
  </li>
  <li>
    <a href="/email/mail-inbox">
      <p>
        <i class="fa fa-circle-o me-3 font-primary"> </i>Delivery processing
        <span class="pull-right">10 min.</span>
      </p></a
    >
  </li>
  <li>
    <a href="/email/read-email">
      <p>
        <i class="fa fa-circle-o me-3 font-success"></i>Order Complete<span
          class="pull-right"
          >1 hr</span
        >
      </p></a
    >
  </li>
  <li>
    <a href="/email/read-email">
      <p>
        <i class="fa fa-circle-o me-3 font-info"></i>Tickets Generated<span
          class="pull-right"
          >3 hr</span
        >
      </p></a
    >
  </li>
  <li>
    <a href="/email/read-email">
      <p>
        <i class="fa fa-circle-o me-3 font-danger"></i>Delivery Complete<span
          class="pull-right"
          >6 hr</span
        >
      </p></a
    >
  </li>
  <li>
    <a class="btn btn-primary" href="/email/read-email"
      >Check all notification</a
    >
  </li>
</ul>
